module.exports = __webpack_public_path__ + "static/media/promotional.beed8707.jpeg";